import React from 'react';
    import { motion } from 'framer-motion';
    import { Link } from 'react-router-dom';
    import * as FiIcons from 'react-icons/fi';
    import SafeIcon from '../common/SafeIcon';

    const { FiArrowRight, FiCalendar, FiTool, FiLink } = FiIcons;

    const CTAFooter = () => {
      const handleLinkClick = () => {
        window.scrollTo(0, 0);
      };

      const handleBookingClick = () => {
        window.open('https://connect.withjahx.com', '_blank');
      };
      
      return (
        <footer className="py-20 relative">
          <div className="container mx-auto px-6">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="text-center mb-16"
            >
              <h2 className="text-4xl md:text-6xl font-orbitron font-bold mb-6">
                Start your <span className="clarity-gradient">clarity journey</span> today
              </h2>
              <p className="text-xl text-gray-300 font-poppins max-w-3xl mx-auto mb-12">
                Join thousands of creative entrepreneurs who've transformed overwhelm into sustainable success.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4 mb-16">
                <a href="https://discord.withjahx.com" target="_blank" rel="noopener noreferrer">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="bg-gradient-to-r from-green-600 to-emerald-600 px-8 py-4 rounded-full font-poppins font-semibold text-lg glow-button flex items-center justify-center space-x-2 w-full sm:w-auto"
                  >
                    <span>Join Clarity Club</span>
                    <SafeIcon icon={FiArrowRight} />
                  </motion.button>
                </a>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleBookingClick}
                  className="border-2 border-purple-500 text-purple-300 px-8 py-4 rounded-full font-poppins font-semibold text-lg hover:bg-purple-500/10 transition-colors flex items-center justify-center space-x-2 w-full sm:w-auto"
                >
                  <SafeIcon icon={FiCalendar} />
                  <span>Book a Discovery Call</span>
                </motion.button>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              viewport={{ once: true }}
              className="border-t border-gray-700 pt-12"
            >
              <div className="flex flex-col md:flex-row items-center justify-between text-gray-400 font-poppins">
                <Link to="/" onClick={handleLinkClick} className="flex items-center space-x-3 mb-4 md:mb-0">
                  <img src="https://storage.googleapis.com/msgsndr/5HRQzDMwpTPxnC7Itr8Z/media/6836617cb09b43dcbc66db28.svg" alt="Clarity with Jahx Logo" className="w-8 h-8" />
                  <span className="font-orbitron font-bold clarity-gradient">
                    Clarity with Jahx
                  </span>
                </Link>
                <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm">
                  <Link to="/affiliate-pathways" onClick={handleLinkClick} className="hover:text-white transition-colors">Affiliate Pathways</Link>
                  <Link to="/prompt-tools" onClick={handleLinkClick} className="hover:text-white transition-colors">Prompt Tools</Link>
                  <a href="https://pages.withjahx.com/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Privacy Policy</a>
                  <a href="https://pages.withjahx.com/terms" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Terms of Service</a>
                  <a href="https://pages.withjahx.com/refund" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Refund Policy</a>
                </div>
              </div>
              <div className="text-center mt-8 text-gray-500 font-poppins text-sm">
                <p>© 2024 Clarity with Jahx. Powered by Lumadious. Built for the creative entrepreneurs who refuse to settle.</p>
              </div>
            </motion.div>
          </div>
        </footer>
      );
    };

    export default CTAFooter;